/**
 * Sayfa geçişlerinde üstte ince ilerleme çubuğu (YouTube / GitHub gibi). navigate ile gidince Gatsby yeni sayfanın
 * verisi (SSR sayfalarda page-data) gelene kadar ekranı değiştirmiyor; kullanıcı "bastım mı?" diye kalıyordu.
 *
 * Gatsby'de geçiş BAŞLARKEN çalışan bir kanca yok (onPreRouteUpdate veri geldikten sonra çalışıyor), bu yüzden
 * gatsby-browser onInitialClientRender'da window.___navigate sarılıp tıklama anında başlatılır; onRouteUpdate'te biter.
 * Kütüphanesiz, düz DOM.
 */
let cubuk = null;
let guvenlik = null;

const ciz = () => {
    if (!cubuk) {
        cubuk = document.createElement("div");
        cubuk.id = "iu-ilerleme";
        cubuk.setAttribute("aria-hidden", "true");
        document.body.appendChild(cubuk);
    }
    return cubuk;
};

export const ilerlemeBaslat = () => {
    if (typeof document === "undefined") return;
    const c = ciz();
    clearTimeout(guvenlik);
    c.style.transition = "none";
    c.style.opacity = "1";
    c.style.width = "0%";
    // eski genişlik uygulansın diye bir kez ölç, sonra tek uzun geçişle akıcı biçimde %90'a: başta hızlı, sonra
    // yavaşlayarak (gerçek ilerleme bilinmiyor). Adım adım (setInterval) artırınca takılarak ilerliyor gibi görünüyordu.
    c.getBoundingClientRect();
    c.style.transition = "width 10s cubic-bezier(0.08, 0.7, 0.2, 1)";
    c.style.width = "90%";
    // geçiş olmazsa (aynı sayfaya tıklama, hata) takılı kalmasın
    guvenlik = setTimeout(ilerlemeBitir, 15000);
};

export const ilerlemeBitir = () => {
    if (!cubuk) return;
    clearTimeout(guvenlik);
    const c = cubuk;
    // o anki genişlikten devam etsin (geçiş yarıda kesilince geri sıçramasın)
    const simdiki = getComputedStyle(c).width;
    c.style.transition = "none";
    c.style.width = simdiki;
    c.getBoundingClientRect();
    c.style.transition = "width 0.25s ease-out, opacity 0.3s ease 0.25s";
    c.style.width = "100%";
    c.style.opacity = "0";
};

/** Gatsby'nin navigate'ini sarar: her istemci geçişinde çubuk başlar. */
export const navigateSar = () => {
    if (typeof window === "undefined" || !window.___navigate || window.___navigate.__iuSarili) return;
    const asil = window.___navigate;
    const sarili = (to, options) => {
        if (typeof to === "string") {
            const hedef = to.split("#")[0];
            const simdiki = window.location.pathname + window.location.search;
            if (hedef && hedef !== simdiki) {
                ilerlemeBaslat();
            }
        }
        return asil(to, options);
    };
    sarili.__iuSarili = true;
    window.___navigate = sarili;
};
